import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer2poc-service.qa.onyxcentersource.com',
  hostname: 'pioneer-ec.qa.onyxcentersource.com',
  portalUrl: 'https://portal.qa.onyxcentersource.com',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.qa.onyxcentersource.com',

  allowApiDocs: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.qaec.ts